import { useState, useEffect } from 'react'
import { Box, Stack, Typography } from '@mui/material'

import Sidebar from './Sidebar'
import Videos from './Videos'

import {fetchFromAPI} from '../data/APIdata'

const Feed = ({lightMode}) => {
const [selectedCategory, setSelectedCategory] = useState('New')
const [videos, setVideos]= useState([])

useEffect(() => {
  fetchFromAPI(`search?part=snippet&q=${selectedCategory}`).then(data=> setVideos(data.items))

}, [selectedCategory])


  return (
    // flexDirection is coloumn and for medium Devices(md) is row
    <Stack sx={{ flexDirection: { sx: 'coloumn', md: 'row' }}}>

      <Box sx={{
        borderRight: '1px solid #3d3d3d',
        px: { sx: 0, md: 2 }}}>
        
        <Sidebar selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} lightMode={lightMode}/>
      </Box>

      <Box p={2} sx={{overflow: 'auto', height: '90vh', flex: 2}}>
        <Typography
        variant='h4' fontWeight='bold' mb={2} sx={{color: lightMode?'black': 'white'}}>
          {selectedCategory} <span style={{color: '#F31503'}}>videos</span>
        </Typography>

        <Videos videos={videos} lightMode={lightMode}/>
      </Box>
    </Stack>
  )
}

export default Feed